export const NAME = 'modal' // eslint-disable-line
